export default __webpack_public_path__ + "static/media/wallet_albedo.17c071b2.svg";